import React from "react";

import { env } from "~/env";

const Support = () => {
  return (
    <section className="flex w-full justify-center gap-1 text-center text-gray-700">
      <div className="text-neutral-800">
        <strong className="font-sans font-semibold">Questions?</strong> Contact
        us at{" "}
        <a className="underline" href={`tel:${env.VITE_SUPPORT_PHONE_NUMBER}`}>
          {env.VITE_SUPPORT_PHONE_NUMBER}
        </a>
        {"  "}
        or{" "}
        <a
          href={`mailto:${env.VITE_ELEKTRA_CARE_EMAIL}`}
          target="_blank"
          aria-label={`${env.VITE_ELEKTRA_CARE_EMAIL} (opens in a new tab)`}
          className="underline"
          role="link"
          rel="noopener noreferrer"
        >
          {env.VITE_ELEKTRA_CARE_EMAIL}
        </a>
      </div>
    </section>
  );
};

export default Support;
